import { Tab, Tabs, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

interface IBatchActionTab {
    value: number;
    handleChange: (event: React.SyntheticEvent, newValue: number) => void;
}

export const BatchActionTab: React.FC<IBatchActionTab> = ({
    value,
    handleChange
}) => {

    const { t } = useTranslation();

    return (
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" variant="fullWidth">
            <Tab
                label={
                    <Typography
                        fontSize="14px"
                        fontFamily="segoe ui"
                        textTransform="none"
                        color="#22638D"
                        fontWeight={value == 0 ? 600 : 400}
                    >
                        {t("BatchActionModal.batchAprovable")}
                    </Typography>
                }
            />
            <Tab
                label={
                    <Typography
                        fontSize="14px"
                        fontFamily="segoe ui"
                        textTransform="none"
                        color="#22638D"
                        fontWeight={value == 1 ? 600 : 400}
                    >
                        {t("BatchActionModal.nonBatchAprovable")}
                    </Typography>
                }
            />
        </Tabs>
    )
}